import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { createMenuLink } from 'redux/menu-links/actions';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import './AddMenuLink.css';


function AddMenuLink(props) {
  const { me, createMenuLink, menuLinksList } = props; 
  const { t } = useTranslation();
  const isPro = me && me.subscription && me.subscription.ff_menu;
  const disabledStarter = !isPro && menuLinksList && menuLinksList.length === 1;

  const isBtnDisable = () => {
    if (disabledStarter) {
      return true;
    }
  }
  
  return (
    <div className="add-price-list-form__component">
      <div className="buttons-block">
        <Button
        disabled={isBtnDisable()}
          onClick={() => {
            createMenuLink();
          }}
        >
          {t("+ Add Price List Item")}
        </Button>
      </div>
      {disabledStarter &&
        <CommonMessage warning>
          {t("You must upgrade to PRO account in order to create more than 1 menu.")}
        </CommonMessage>
      }      
    </div>
  );
}


AddMenuLink.propTypes = {
  me: PropTypes.object,
  createMenuLink: PropTypes.func.isRequired,
}

AddMenuLink.defaultProps = {
  menuLinksList: null,
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    menuLinksList: state.menuLinksReducer.menuLinksList,
  }
);

export default connect(
  mapStateToProps, 
  { 
    createMenuLink, 
  },
)(AddMenuLink);